module.exports = __webpack_public_path__ + "img/Sunu-Widyatmoko.c5b7cda7.png";